export default __webpack_public_path__ + "static/media/Sandals of the Ubah Kan.1be39c6c.jpg";